if (!customElements.get("scroll-to-top")) {
  class ScrollToTop extends HTMLElement {
    constructor() {
      super();
      this.triggerHeight  = window.innerHeight;
      this.handleScrollEvent = this.toggleVisibility.bind(this);
    }

    connectedCallback() {
      this.addEventListener("click", this.scrollToTopHandler);
      window.addEventListener("scroll", this.handleScrollEvent);
      this.toggleVisibility();
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.scrollToTopHandler);
      window.removeEventListener("scroll", this.handleScrollEvent);
    }

    toggleVisibility() {
      const isButtonVisible = window.scrollY > this.triggerHeight;
      this.classList.toggle("scroll-to-top--visible", isButtonVisible);
    }

    scrollToTopHandler() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  customElements.define("scroll-to-top", ScrollToTop);
}
// ✅ Add scroll-to-top behavior for a separate class element
document.addEventListener("DOMContentLoaded", () => {
  const imageTrigger = document.querySelector(".scroll-to-top-new");

  if (imageTrigger) {
    imageTrigger.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const detailsMenu = document.querySelector('details.menu-drawer-container');
  const scrollTopEl = document.querySelector('scroll-to-top');
  let crispChatbox = document.querySelector('#crisp-chatbox');

  if (!detailsMenu || !scrollTopEl) return;

  function hideCrisp() {
    if (!crispChatbox) return;
    scrollTopEl.classList.remove('scroll-to-top--visible');
    crispChatbox.style.setProperty('display', 'none', 'important');
  }

  function showCrisp() {
    if (!crispChatbox) return;
    scrollTopEl.toggleVisibility?.();
    crispChatbox.style.removeProperty('display');
  }

  function setupToggleListener() {
    detailsMenu.addEventListener('toggle', () => {
      if (!crispChatbox) return;
      if (detailsMenu.open) {
        hideCrisp();
      } else {
        showCrisp();
      }
    });
  }

  function checkAndHideIfMenuOpen() {
    if (detailsMenu.open && crispChatbox) {
      hideCrisp();
    }
  }

  if (crispChatbox) {
    setupToggleListener();
    checkAndHideIfMenuOpen();
  } else {
    // Watch for Crisp loading dynamically after page load
    const observer = new MutationObserver((mutations, obs) => {
      crispChatbox = document.querySelector('#crisp-chatbox');
      if (crispChatbox) {
        setupToggleListener();
        checkAndHideIfMenuOpen();  // Immediately hide if menu open now
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Scroll to top button handler (unchanged)
  const imageTrigger = document.querySelector(".scroll-to-top-new");
  if (imageTrigger) {
    imageTrigger.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
});

